/**
 * @property title {string} title
 */
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
class CommonNav extends Component {
  render() {
    return (
      <div className="segment-list-title clearfix">
        <span>{this.props.title}</span>
        <div className="nav">
          <ul className="link clearfix">
            <li>
              <NavLink
                exact
                to={`/segments/list/active`}
                activeClassName="active"
              >
                Active
              </NavLink>
            </li>
            <li></li>
            <li>
              <NavLink
                exact
                to={`/segments/list/archive`}
                activeClassName="active"
              >
                Archive
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default CommonNav;



// WEBPACK FOOTER //
// ./src/components/Segment/List/CommonNav.jsx